export default __webpack_public_path__ + "static/media/img-slider-token-2.17b13929.png";